<template>
  <div class="solution">
    <nav-bar @anchorJump="anchorJump" :main-index="2"></nav-bar>
    <img src="../assets/images/solutionBg.png" style="display: none" alt="选择直达" />
    <section id="0" class="part-one">
      <div class="left-col">
        <h1>为何选择直达 ？</h1>
        <article>
          <p>通过部署直达软件的交易系统来提高客户满意度</p>
          <p>降低管理昂贵的基础架构的成本</p>
          <p>基于公司雄厚的经济实力、完善的团队人员管理、深耕多年的交易解决方案，</p>
          <p>
            我们为客户提供
            <span>白标方案即OEM方案</span>，搭建自己专属的商标和品牌
          </p>
        </article>
      </div>
      <div class="right-col">
        <article>
          <h3>我们为您提供：</h3>
          <p>直接交易市场接入（DMA）</p>
          <p>快速并且稳定的网络</p>
          <p>期货证券一站式交易平台</p>
          <p>专业的技术支持</p>
          <p>客户及后台管理系统</p>
        </article>
      </div>
    </section>
    <section id="1" class="part-two">
      <h2>基础设施</h2>
      <div class="infrastructure">
        <div
          class="wow slideInUp list"
          v-for="(item, index) in infrastructureList"
          :key="index"
          :data-wow-duration="item.duration"
          offset="0"
        >
          <dt>{{item.title}}</dt>
          <p>{{item.article}}</p>
          <dl>
            <dd v-for="i_list in item.list" :key="i_list">{{i_list}}</dd>
          </dl>
        </div>
      </div>
    </section>
    <section id="2" class="part-three">
      <div class="left-col">
        <h2 class="wow slideInLeft" data-wow-duration="1300ms" offset="0">软件平台</h2>
        <p class="wow slideInLeft" data-wow-duration="1500ms" offset="0">下单执行速度1ms以内</p>
        <p class="wow slideInLeft" data-wow-duration="1800ms" offset="0">每秒支持1000笔委托</p>
      </div>
      <div class="right-col">
        <img src="../assets/images/world_map.png" style="display: none" alt="软件平台" />
        <canvas id="canvas1" width="1291" height="625" style="position: absolute"></canvas>
        <canvas id="canvas2" width="1291" height="625" style="position: absolute"></canvas>
        <canvas id="canvas3" width="1291" height="625" style="position: absolute"></canvas>
        <canvas id="canvas4" width="1291" height="625" style="position: absolute"></canvas>
        <div class="map">
          <div class="point point1 point-flicker">
            <span>芝加哥</span>
          </div>
          <div class="point point2 point-flicker">
            <span>北京</span>
          </div>
          <div class="point point3 point-flicker">
            <span>上海</span>
          </div>
          <div class="point point4 point-flicker">
            <span>香港</span>
          </div>
          <div class="point point5 point-flicker">
            <span>新加坡</span>
          </div>
        </div>
      </div>
    </section>
    <section id="3" class="part-four">
      <div class="thirdparty">
        <dt>第三方应用接入</dt>
        <p>
          自主研发的API，可以让第三方应用接入交易与行情;
          <br />采用类似CTP接口的设计，使得有CTP接口使用经验的用户能够快速上手开发
        </p>
        <dl class="wow slideInUp" data-wow-duration="1000ms" offset="0">
          <dd>开放的API接口</dd>
          <dd>延迟大幅降低</dd>
          <dd>支持自主研发和数据接入</dd>
        </dl>
      </div>
    </section>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  name: "solution",
  components: {
    navBar: navBar
  },
  data() {
    return {
      subnav: this.$route.params.subnav,
      clientHeight: document.documentElement.clientHeight,
      clientWidth: document.documentElement.clientWidth,
      target: 0,
      scrollTop: 0,
      ctx: null,
      percent1: 0,
      percent2: 0,
      percent3: 0,
      percent4: 0,
      infrastructureList: [
        {
          title: "稳",
          article:
            "直达在全球各地包括芝加哥，香港，新加坡，上海，北京等地区数据中心部署设备，以提供不同地区客户的需要各数据中心之间均有主备专线连接，最大程度保证交易的稳定",
          list: ["数据同步传输", "传输速度快", "丢包率低", "更具安全性"],
          duration: "1500ms"
        },
        {
          title: "准",
          article:
            "芝加哥商品交易所,港交所,新交易所均是直连接入，可以接受每一笔行情数据",
          list: ["支持回测", "实时通信", "高频率读取数据"],
          duration: "2000ms"
        },
        {
          title: "快",
          article: "中美网络时延143ms，和交易所连接专线带宽高达1G",
          list: ["高频交易", "直连交易所", "降低市场风险"],
          duration: "2500ms"
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW().init();
      this.lineCanvas1();
      setTimeout(() => {
        this.lineCanvas2();
      }, 2000);
      setTimeout(() => {
        this.lineCanvas3();
      }, 4000);
      setTimeout(() => {
        this.lineCanvas4();
      }, 4500);
      //获取指定的div盒
      this.windowScroll();
    });
  },
  created() {
    console.log(this.clientWidth)
    // window.addEventListener("scroll", this.windowScroll);
  },
  methods: {
    windowScroll() {
      //获取指定的div盒
      let targetbox = document.getElementById(this.subnav);
      //获取这个div盒的高度位置
      this.target = targetbox.offsetTop;
      //将滚动条定位到这个高度位置
      document.documentElement.scrollTop = this.target - 78;
      // this.scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
    },
    anchorJump(index) {
      this.subnav = index;
      this.$nextTick(() => {
        this.windowScroll();
      });
    },
    lineCanvas1() {
      var canvas = document.getElementById("canvas1");
      this.ctx = canvas.getContext("2d");
      this.ctx.setLineDash([5, 4]);
      this.ctx.strokeStyle = "#f3a954";
      this.animate1();
      // 芝加哥 -- 上海

      // this.ctx.beginPath();
      // this.ctx.moveTo(205, 192);
      // this.ctx.quadraticCurveTo(615, 20, 1025, 222);
      // this.ctx.stroke();

      // // 香港 -- 芝加哥
      // this.ctx.beginPath();
      // this.ctx.moveTo(215, 200);
      // this.ctx.quadraticCurveTo(515, 420, 1005, 282);
      // this.ctx.stroke();

      // // 上海 -- 北京
      // this.ctx.beginPath();
      // this.ctx.moveTo(980, 100);
      // this.ctx.quadraticCurveTo(1045, 140, 1028, 220);
      // this.ctx.stroke();

      // // 上海 -- 北京
      // this.ctx.beginPath();
      // this.ctx.moveTo(1015, 280);
      // this.ctx.quadraticCurveTo(1020, 335, 955, 352);
      // this.ctx.stroke();
    },
    async lineCanvas2() {
      var canvas = document.getElementById("canvas2");
      this.ctx = canvas.getContext("2d");
      this.ctx.setLineDash([5, 4]);
      this.ctx.strokeStyle = "#f3a954";
      this.animate2();
    },
    lineCanvas3() {
      var canvas = document.getElementById("canvas3");
      this.ctx = canvas.getContext("2d");
      this.ctx.setLineDash([5, 4]);
      this.ctx.strokeStyle = "#f3a954";
      this.animate3();
    },
    lineCanvas4() {
      var canvas = document.getElementById("canvas4");
      this.ctx = canvas.getContext("2d");
      this.ctx.setLineDash([5, 4]);
      this.ctx.strokeStyle = "#f3a954";
      this.animate4();
    },

    animate1() {
      this.ctx.clearRect(0, 0, 10000, 10000);
      // 芝加哥 -- 上海
      if (this.clientWidth >= 1920) {
        var center1 = [205, 192];
        var center2 = [1035, 225];
      }
      if (this.clientWidth >= 1680 && this.clientWidth < 1919) {
        var center1 = [158, 148];
        var center2 = [765, 136];
      }
      if (this.clientWidth >= 1440 && this.clientWidth < 1679) {
        var center1 = [155, 131];
        var center2 = [675, 129];
      }
      if (this.clientWidth < 1440) {
        var center1 = [155, 131];
        var center2 = [675, 129];
      }
      this.ctx.beginPath();
      this.drawCurvePath(this.ctx, center1, center2, 0.15, this.percent1);
      this.ctx.stroke();

      this.percent1 = (this.percent1 + 1) % 100;
      var rafId = requestAnimationFrame(this.animate1);
      if (this.percent1 == 99) {
        cancelAnimationFrame(rafId);
      }
    },
    animate2() {
      this.ctx.clearRect(0, 0, 10000, 10000);
      // 香港 -- 芝加哥
      if (this.clientWidth >= 1920) {
        var center1 = [1010, 272];
        var center2 = [200, 193];
      }
      if (this.clientWidth >= 1680 && this.clientWidth < 1919) {
        var center1 = [778, 209];
        var center2 = [158, 148];
      }
      if (this.clientWidth >= 1440 && this.clientWidth < 1679) {
        var center1 = [700, 189];
        var center2 = [140, 135];
      }
      if (this.clientWidth < 1440) {
        var center1 = [700, 189];
        var center2 = [140, 135];
      }
      this.ctx.beginPath();
      this.drawCurvePath(this.ctx, center1, center2, 0.15, this.percent2);
      this.ctx.stroke();

      this.percent2 = (this.percent2 + 1) % 100;
      var rafId = requestAnimationFrame(this.animate2);
      if (this.percent2 == 99) {
        cancelAnimationFrame(rafId);
      }
    },
    animate3() {
      this.ctx.clearRect(0, 0, 10000, 10000);
      // 香港 -- 新加坡
      if (this.clientWidth >= 1920) {
        var center1 = [1010, 275];
        var center2 = [985, 360];
      }
      if (this.clientWidth >= 1680 && this.clientWidth < 1919) {
        var center1 = [778, 209];
        var center2 = [763, 278];
      }
      if (this.clientWidth >= 1440 && this.clientWidth < 1679) {
        var center1 = [705, 189];
        var center2 = [680, 250];
      }
      if (this.clientWidth < 1440) {
        var center1 = [705, 189];
        var center2 = [680, 250];
      }
      this.ctx.beginPath();
      this.drawCurvePath(this.ctx, center1, center2, 0.2, this.percent3);
      this.ctx.stroke();

      this.percent3 = (this.percent3 + 3) % 100;
      var rafId = requestAnimationFrame(this.animate3);
      if (this.percent3 == 99) {
        cancelAnimationFrame(rafId);
      }
    },
    animate4() {
      this.ctx.clearRect(0, 0, 10000, 10000);
      // 上海 -- 北京
      if (this.clientWidth >= 1920) {
        var center1 = [1028, 225];
        var center2 = [975, 179];
      }
      if (this.clientWidth >= 1680 && this.clientWidth < 1919) {
        var center1 = [796, 172];
        var center2 = [760, 135];
      }
      if (this.clientWidth >= 1440 && this.clientWidth < 1679) {
        var center1 = [715, 155];
        var center2 = [660, 128];
      }
      if (this.clientWidth < 1440) {
        var center1 = [715, 155];
        var center2 = [660, 128];
      }
      this.ctx.beginPath();
      this.drawCurvePath(this.ctx, center1, center2, -0.25, this.percent4);
      this.ctx.stroke();

      this.percent4 = (this.percent4 + 3) % 100;
      var rafId = requestAnimationFrame(this.animate4);
      if (this.percent4 == 99) {
        cancelAnimationFrame(rafId);
      }
    },
    drawCurvePath(ctx, start, end, curveness, percent) {
      var cp = [
        (start[0] + end[0]) / 2 - (start[1] - end[1]) * curveness,
        (start[1] + end[1]) / 2 - (end[0] - start[0]) * curveness
      ];
      var t = percent / 100;
      var p0 = start;
      var p1 = cp;
      var p2 = end;
      var v01 = [p1[0] - p0[0], p1[1] - p0[1]]; // 向量<p0, p1>
      var v12 = [p2[0] - p1[0], p2[1] - p1[1]]; // 向量<p1, p2>
      var q0 = [p0[0] + v01[0] * t, p0[1] + v01[1] * t];
      var q1 = [p1[0] + v12[0] * t, p1[1] + v12[1] * t];
      var v = [q1[0] - q0[0], q1[1] - q0[1]]; // 向量<q0, q1>
      var b = [q0[0] + v[0] * t, q0[1] + v[1] * t];
      ctx.moveTo(p0[0], p0[1]);
      ctx.quadraticCurveTo(q0[0], q0[1], b[0], b[1]);
    }
  }
};
</script>

<style lang="scss" scoped>
.solution {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 78px;
  background: url("../assets/images/winCooperationBg.png") center 78px no-repeat;
  background-size: 100%;
  .part-one {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-around;
    .left-col {
      h1 {
        font-weight: bold;
        color: #ffa63e;
      }
      p {
        font-weight: 300;
        span {
          color: #ffa63e;
        }
      }
    }
    .right-col {
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 0.15);
      h3 {
        font-weight: 400;
        color: #ffa63e;
      }
      p {
        width: 100%;
        float: left;
        position: relative;
        box-sizing: border-box;
        &::before {
          content: "";
          position: absolute;
          border-radius: 50%;
          display: block;
          background: #00a0e9;
        }
      }
    }
  }

  .part-two {
    position: relative;
    z-index: 10;
    h2 {
      color: #ffa63e;
      font-weight: 700;
      text-align: center;
    }
    .infrastructure {
      padding: 20px 50px 120px;
      display: flex;
      justify-content: center;
      .list {
        flex: 1;

        box-sizing: border-box;
        &:nth-child(1) {
          background: url("../assets/images/infrastructureBg01.png");
          background-size: 100% 100%;
        }
        &:nth-child(2) {
          background: url("../assets/images/infrastructureBg03.png");
          background-size: 100% 100%;
        }
        &:nth-child(3) {
          background: url("../assets/images/infrastructureBg02.png");
          background-size: 100% 100%;
        }
        dt {
          font-weight: bold;
          color: #ffa63e;
        }
        dd {
          width: 50%;
          float: left;
          position: relative;
          box-sizing: border-box;
          &::before {
            content: "";
            position: absolute;
            border-radius: 50%;
            display: block;
            background: #00a0e9;
          }
        }
      }
    }
  }

  .part-three {
    display: flex;
    .left-col {
      flex: 1;
      h2 {
        font-weight: bold;
        color: #ffa63e;
      }
      p {
        width: 100%;
        float: left;
        position: relative;
        box-sizing: border-box;
        &::before {
          content: "";
          position: absolute;
          border-radius: 50%;
          display: block;
          background: #00a0e9;
        }
      }
    }
    .right-col {
      background: url("../assets/images/world_map.png") center no-repeat;
      background-size: 100%;
      position: relative;

      #canvas {
        position: absolute;
        right: 1px;
        left: 1px;
      }

      .map {
        position: relative;
        z-index: 1;
      }

      .point {
        position: absolute;
        display: inline-block;
        background: #f3a954;
        border-radius: 50%;
        &:hover span {
          // background: #f3a954;
          color: #f3a954;
          // box-shadow: 0 0 5px #ffff, 0 0 25px #fff, 0 0 50px #fff,
          //   0 0 200px #fff;
          -webkit-box-reflect: below 1px linear-gradient(transparent, #0005);
        }
        span {
          position: absolute;
          display: inline-block;
        }
      }

      /* 设置动画前颜色 */
      .point-flicker:after {
        background-color: #f3a954;
      }

      /* 设置动画后颜色 */
      .point-flicker:before {
        background-color: #fff;
      }

      /* 设置动画 */
      .point-flicker:before,
      .point-flicker:after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        animation: warn 1s ease-out 0s infinite;
      }

      /* @keyframes 规则用于创建动画。在 @keyframes 中规定某项 CSS 样式，就能创建由当前样式逐渐改为新样式的动画效果。 */
      @keyframes warn {
        0% {
          transform: scale(0.5);
          opacity: 1;
        }

        30% {
          opacity: 1;
        }

        100% {
          transform: scale(1.4);
          opacity: 0;
        }
      }
    }
  }

  .part-four {
    background: #1f293b;
    opacity: 0.9;
    text-align: center;
    .thirdparty {
      dt {
        font-weight: bold;
        color: #ffa63e;
      }
      p {
        margin: 0 auto;
        color: #ffffff;
      }
      dl {
        text-align: center;
        display: inline-block;
        zoom: 1;
        dd {
          float: left;
          position: relative;
          box-sizing: border-box;

          &::before {
            content: "";
            position: absolute;
            border-radius: 50%;
            display: block;
            height: 11px;
            background: #00a0e9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/solution.vue